import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  scrolled?: boolean;
  compact?: boolean;
}

export default function LanguageSwitcher({ scrolled = true, compact = false }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.startsWith('fr') ? 'fr' : 'en';

  const toggle = () => {
    const next = currentLang === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(next);
  };

  if (compact) {
    return (
      <button
        onClick={toggle}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold border transition-colors cursor-pointer whitespace-nowrap border-gray-200 text-gray-700 hover:border-orange-300 hover:text-orange-500"
        title={currentLang === 'fr' ? 'Switch to English' : 'Passer en Français'}
      >
        <i className="ri-translate-2 text-sm"></i>
        {currentLang === 'fr' ? 'EN' : 'FR'}
      </button>
    );
  }

  return (
    <button
      onClick={toggle}
      className={`flex items-center gap-1.5 px-3 py-2 rounded-full text-sm font-bold transition-colors cursor-pointer whitespace-nowrap ${
        scrolled
          ? 'text-gray-700 hover:text-orange-500 hover:bg-orange-50'
          : 'text-white hover:text-orange-300'
      }`}
      title={currentLang === 'fr' ? 'Switch to English' : 'Passer en Français'}
    >
      <i className="ri-translate-2 text-base"></i>
      <span>{currentLang === 'fr' ? 'EN' : 'FR'}</span>
    </button>
  );
}
